import { staticFile } from "remotion";

/**
 * Two kinds of files, two routes in.
 *
 * The small ones (the artboards' pictures, the store badges, the effect packs) are committed under
 * public/featureintro and always come from there. The heavy ones (clips, photos, music) are not
 * committed: they arrive as props, so the render box can be handed https URLs, while a local render
 * reads them from the gitignored public/featureintro/media folder.
 */
export const asset = (path: string) => staticFile(`featureintro/${path}`);

/** A media source from props: an https URL is used as is, anything else is a path in the public dir. */
export const mediaSrc = (src: string) => (/^https:\/\//i.test(src) ? src : staticFile(src));
